<div class="header-container">
  <div (click)="back()" >
    <img height="24" ngSrc="../../../../assets/img/back-carret.svg" width="24">
  </div>
  <div class="label1">
    {{ title() }}
  </div>
  <div></div>
</div>
